import { StyleConstant } from 'util/getStyleConstant';
import styled, { css } from 'styled-components';

export const StyledCase = styled.div`
  &:focus {
    outline: 0;
  }
`;
export const StyledCaseContent = styled.div<{
  raw?: boolean;
}>`
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.04);

  @media print {
    box-shadow: none;
  }

  &:focus {
    outline: 0;
  }

  @media screen and (min-width: 1440px) {
    .case-content {
      max-width: 48vw;
    }
  }

  @media screen and (min-width: ${StyleConstant.BREAKPOINT_HANDHELD}) {
    &.case-content-container {
      flex: 1 1 auto;
    }

    .case-content {
      &-with-footer {
        footer {
          display: block;
        }
      }
    }
  }

  .case-content {
    color: var(--COLOR_BLACK);
    font-family: 'Zilla Slab', serif;
    margin: 64px auto;
    max-width: 675px;
    padding: 0 116px;
    position: relative;
    &-with-footer {
      overflow: auto;
    }
    @media only print {
      margin: 0;
      padding: 28px;
      max-width: none;
    }
    .hidden {
      display: none;
    }
    .case-header {
      margin-bottom: 2em;
      text-align: center;
      line-height: 1.5em;
      .publication {
        font-size: 0.8em;
      }
    }
    .parties {
      font-size: 22px;
      font-weight: bold;
      line-height: 2;
      margin-bottom: 1.1em;
      @media only print {
        font-size: 18px;
      }
      .party {
        line-height: 1.3;
        margin-bottom: 6px;
        > span {
          display: inline-block;
          margin-bottom: 6px;
        }
        .roles {
          font-size: 16px;
          font-weight: normal;
          line-height: 1.5;
        }
      }
    }
    hr {
      border-top: 1px solid var(--COLOR_ALTO);
      border: 0;
      margin: 0 auto;
      width: 75%;
      @media only print {
        border-top: 1px solid black;
        width: 100%;
      }
    }
    mark,
    span:focus,
    .focused {
      background-color: var(--COLOR_CITRINE_WHITE);
      outline: 0;
      @include selection {
        & {
          background-color: rgba(206, 232, 249, 0.999);
        }
      }
    }
    .case-body {
      font-size: 17px;
      padding-top: 2.5em;
      @media only print {
        font-size: 14px;
      }
      a,
      a:visited {
        color: inherit;
        &[data-case-url-id],
        &[data-statute-section] {
          color: var(--COLOR_NICE_BLUE);
          cursor: pointer;
          text-decoration: underline;
          @media only print {
            color: black;
            font-weight: bold;
          }
        }
      }
      blockquote {
        max-width: 80%;
        margin: 0 auto;
      }
      p,
      blockquote,
      pre {
        font-size: inherit;
        margin-bottom: 1.4em;
        line-height: 1.6em;
      }
      pre {
        overflow: auto;
      }
      .heading {
        font-size: 28px;
        text-align: center;
        margin-bottom: 17px;
        p {
          margin: 0;
          font-size: inherit;
        }
      }
      .counsel {
        p {
          margin-bottom: 1.8em;
        }
      }
      .opinionauthor {
        font-size: 17px;
        margin-bottom: 2em;
      }
      .notes {
        border-top: 1px solid var(--COLOR_ALTO);
        padding-top: 20px;
        p {
          font-size: 13px;
        }
      }
      .opinion,
      .appendix {
        .pagenumber {
          color: var(--COLOR_BLACK);
          font-weight: normal;
          @media only print {
            font-weight: bold;
          }
          &:before {
            opacity: 0.35;
            display: inline-block;
            content: attr(val);
            padding: 0 0.3em;
            color: var(--COLOR_BLACK);
            @media only print {
              color: black;
              content: '*' attr(margin);
              opacity: 1;
            }
          }
          &:after {
            color: color-mix(in srgb, var(--COLOR_BLACK) 35%, transparent);
            ${({ raw }) =>
              !raw &&
              css`
                background: var(--COLOR_VERY_LIGHT_PINK);
              `}
            position: absolute;
            left: 28px;
            font-size: 17px;
            content: attr(margin);
            @media only print {
              display: none;
            }
          }
        }
      }
    }
    .notemarker,
    .noteanchor {
      cursor: pointer;
      font-weight: normal;
      line-height: 1;
      &:before {
        display: inline-block;
        content: attr(val);
        color: var(--COLOR_BUTTERED_RUM);
        padding: 0 0.25em;
        @media only print {
          color: black;
        }
      }
    }
    .notemarker:before {
      padding: 0 0.5em;
    }

    iframe {
      border: 0;
      width: 100%;
      height: 500px;
    }

    img {
      width: 100%;
    }
  }
`;
